import React from 'react';
import { useDispatch } from 'react-redux';
import { approveInvoiceDocs } from 'src/store/actions/invoice-actions';
import { toast } from 'react-toastify';
import { IInvoiceChange } from 'src/types/invoiceChange';

interface Props {
    data: IInvoiceChange;
}

const DeleteInvoiceChangeAction: React.FunctionComponent<Props> = ({ data: { id } }: Props) => {
    const dispatch = useDispatch();

    return (
        <>
            <button
                type="button"
                className={'btn btn-success'}
                onClick={() =>
                    dispatch(
                        approveInvoiceDocs(
                            id,
                            { isApprove: true },
                            () => {
                                toast.success('Invoice was successfully approved!');
                            },
                            (errorMessage: string) => {
                                toast.error(errorMessage);
                            },
                        ),
                    )
                }
            >
                Approve
            </button>
        </>
    );
};

export default DeleteInvoiceChangeAction;
